import React from "react";

export const CloseIcon = () => {
  return (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.818942 1.59067C0.605926 1.37765 0.605926 1.03229 0.818942 0.819278C1.03195 0.606261 1.37732 0.606261 1.59033 0.819278L3.00283 2.23179L4.41223 0.822393C4.62523 0.609382 4.97061 0.609382 5.18361 0.822393C5.39661 1.03541 5.39661 1.38077 5.18361 1.59379L3.77421 3.00317L5.18366 4.41257C5.39666 4.62562 5.39666 4.97095 5.18366 5.184C4.97061 5.39701 4.62528 5.39701 4.41223 5.184L3.00283 3.77455L1.59349 5.1839C1.38048 5.3969 1.03512 5.3969 0.822106 5.1839C0.609089 4.9709 0.609089 4.62551 0.822106 4.41251L2.23145 3.00317L0.818942 1.59067Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};

